<template>
    <ModalComponent
        ref="modal"
        :name="'cambiar-imagen-' + evento.id"
        title="Editar imagen entrada"
        v-on:close="() => close(false)"
    >
        <div v-if="!loading">
            <label for="imagen">Imagen cabecera email:</label>
            <p>
                <small>
                    MEDIDAS: 2182X287 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                    <br/>
                    * No introduzcas texto en la imagen.
                </small>
            </p>
  
            <template v-if="evento.imagen_cabecera">
                <img :src="evento.imagen_cabecera_url" style="max-height: 300px"/>
                <div>
                    <Button class="mt-1" @click="btnImagenBorrada('imagen_cabecera')">Borrar</Button>
                </div>
            </template>
            <Dropzone 
                v-if="url && !evento.imagen_cabecera"
                :url="url"
                :height="287"
                :width="2182"
                @success="imagenSubida('imagen_cabecera', ...arguments)"
            />
            <label for="imagen" class="mt-4">Imagen publicidad email:</label>
            <p>
                <small>
                    MEDIDAS: 2182X667 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                    <br/>
                    * No introduzcas texto en la imagen.
                </small>
            </p>
            <template v-if="evento.imagen_publicidad">
                <img :src="evento.imagen_publicidad_url" style="max-height: 300px"/>
                <div>
                    <Button class="mt-1" @click="btnImagenBorrada('imagen_publicidad')">Borrar</Button>
                </div>
            </template>
            <Dropzone 
                v-if="url && !evento.imagen_publicidad"
                :url="url"
                :height="667"
                :width="2182"
                @success="imagenSubida('imagen_publicidad', ...arguments)"
            />
            <label for="imagen" class="mt-4">Imagen patrocinadores email:</label>
            <p>
                <small>
                    MEDIDAS: 2182X319 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                    <br/>
                    * No introduzcas texto en la imagen.
                </small>
            </p>
            <template v-if="evento.imagen_patrocinadores">
                <img :src="evento.imagen_patrocinadores_url" style="max-height: 300px"/>
                <div>
                    <Button class="mt-1" @click="btnImagenBorrada('imagen_patrocinadores')">Borrar</Button>
                </div>
            </template>
            <Dropzone 
                v-if="url && !evento.imagen_patrocinadores"
                :url="url"
                :height="319"
                :width="2182"
                @success="imagenSubida('imagen_patrocinadores', ...arguments)"
            />
        </div>
 

        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <Button @click="guardarOpciones">Guardar</Button>
                <Button type="button" name="button" @click.prevent="$refs['modal'].close()">CERRAR</Button>
            </div>
        </template>

        <template v-if="loading">
            <div class="card-body">
                <LoaderComponent/>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['evento'],
        data() {
            return {
                loading: false,
                url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public'
            }
        },
        methods: {
            guardarOpciones() {
                this.loading = true;

                const params = {
                    filters: {},
                    evento_id: this.evento.id,
                    imagen_patrocinadores: this.evento.imagen_patrocinadores,
                    imagen_cabecera: this.evento.imagen_cabecera,
                    imagen_publicidad: this.evento.imagen_publicidad
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.editar.imagenes-entradas'), params).then(res => {
                    this.$toast.success(res.data.message);
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false;
                        this.close();
                    }, 500);
                });
            },
            close() {
                this.$emit('close', 'cambiar-imagen-' + this.evento.id, true);
            },
            clearEventImage(campo) {
                switch (campo) {
                    case 'imagen_patrocinadores':
                        this.evento.imagen_patrocinadores = null;
                        this.evento.imagen_patrocinadores_url = null;
                        break;
                    case 'imagen_cabecera':
                        this.evento.imagen_cabecera = null;
                        this.evento.imagen_cabecera_url = null;
                        break;
                    case 'imagen_publicidad':
                        this.evento.imagen_publicidad = null;
                        this.evento.imagen_publicidad_url = null;
                        break;
                }
            },
            btnImagenBorrada(campo) {
                this.clearEventImage(campo);
            },
            imagenBorrada(campo) {
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'imagen_patrocinadores':
                        this.evento.imagen_patrocinadores = response;
                        this.evento.imagen_patrocinadores_url = 'https://storage.compralaentrada.com/' + response;
                        break;
                    case 'imagen_cabecera':
                        this.evento.imagen_cabecera = response;
                        this.evento.imagen_cabecera_url = 'https://storage.compralaentrada.com/' + response;
                        break;
                    case 'imagen_publicidad':
                        this.evento.imagen_publicidad = response;
                        this.evento.imagen_publicidad_url = 'https://storage.compralaentrada.com/' + response;
                        break;
                }
            },
        },
        components: {
            ModalComponent, Dropzone
        }
    }
</script>
